/**
 * Created by Andrey Popov on 22/04/20
 */

const UseGoldButton = cleverapps.UI.Button.extend({
    ctor: function (options) {
        this.price = options.price;
        this.source = options.source;
        this.onFilterHandler = options.filter || function () {
            return true;
        };
        this.onClickHandler = function () {
            options.onClicked();
        };
        this.eventName = options.eventName;
        this.confirmWindowOptions = options.confirmWindowOptions;

        if (this.price && options.canCoins) {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_BOOSTTIME);
            if (mission && MissionManager.hasProperLocation(mission.type)) {
                this.useCoins = true;
                this.price *= UseGoldButton.RUBY_COINS_RATE;
            }
        } else if (this.price && options.useCoins) {
            this.useCoins = true;
        }

        this._super({
            width: options.width,
            height: options.height,
            text: this.getText(options),
            onClicked: this.onClick.bind(this),
            type: options.type,
            disabled: options.disabled
        });
        this.adviceTarget = options.adviceTarget;
    },

    getText: function (options) {
        if (!this.price) {
            return `${Messages.get("UseGoldButton.free")}${options.freeIcon || ""}`;
        }

        if (options.text) {
            return options.text;
        }

        let string = this.useCoins ? `@@${this.price}` : `$$${this.price}`;

        if (options.speedUp) {
            string += ">>";
        }

        return string;
    },

    takeCurrency: function () {
        const source = this.source || this;
        return (this.useCoins) ? cleverapps.user.spendSoft(this.eventName, this.price, { source })
            : cleverapps.user.spendHard(this.eventName, this.price);
    },

    onClick: function () {
        if (this.confirmWindowOptions) {
            this.showConfirmWindow();
            return;
        }

        if (this.onFilterHandler() && this.takeCurrency()) {
            this.onClickHandler();
        }
    },

    showConfirmWindow: function () {
        const displayConfirmWindow = function () {
            new ConfirmSpeedUpWindow({
                price: this.confirmWindowOptions.price,
                timeLeft: this.confirmWindowOptions.timeLeft,
                totalDuration: this.confirmWindowOptions.totalDuration,
                eventName: this.eventName,
                callback: this.onClickHandler
            });
        }.bind(this);

        cleverapps.focusManager.display({
            stack: true,
            focus: "ConfirmSpeedUpWindow",
            action: function (f) {
                displayConfirmWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
});

UseGoldButton.RUBY_COINS_RATE = 5;